<template lang="pug">
div
  b-tooltip(target="adventure-guide" title="Adventurer’s Guide", triggers="hover")
  b-nav-item-dropdown.guide-item
    template(slot='button-content')
      img#adventure-guide(src='../../assets/nav/compass.svg', @click='toggleGuide()', :class="{pulse: recsCount > 0 && favoriteMonster.name}")
      .notif.d-flex.align-items-center.justify-content-center(v-if='recsCount > 0 && favoriteMonster.name')
        span {{ recsCount }}
  .guide(v-if='displayAdventureGuide')
    .top-item.text-center.d-flex.align-items-center.justify-content-center
      div
        img.compass(src='../../assets/nav/compass.svg')
        | Adventurer’s Guide
      .close-item(@click='close()') x
    .rec(v-if='metaMaskStatus', :class='{complete: !noBlockchainSprites}', @click='goToMarket()').d-flex.align-items-center
      .check-wrap
        .check-circle.d-flex.align-items-center.justify-content-center
          img.tick(src='../../assets/tick.svg')
      div
        h5 Purchase your first Sprite token
        p Start your journey off strong by adopting your very first sprite that can grow with you.
        p Beginning of a Great Friendship
    // @TODO: Add a challenge to create a new event
    .rec(:class='{complete: allEvents.length !== 0}', v-b-modal.create-event='').d-flex.align-items-center
      .check-wrap
        .check-circle.d-flex.align-items-center.justify-content-center
          img.tick(src='../../assets/tick.svg')
      div
        h5 Create your first event
        p Events are battles your sprite enters to earn a bunch of experience and level up!
        p A Challenger Approaches!
</template>

<style lang="scss">
  .guide-item .dropdown-toggle::after {
    border: none !important;
  }

  .guide-item .dropdown-menu {
    display: none !important;
  }

  .guide {
    border: none !important;
    z-index: 2;
    right: 0;
    position: absolute;
    background: #fff;
    padding-top: 0;
    width: 384px;
    border: none;
    box-shadow: 0 4px 8px 0 rgba(31, 31, 31, 0.16), 0 4px 8px 0 rgba(31, 31, 31, 0.24);
    min-height: 100vh;
    height: 1810px;
    font-size: 14px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.43;
    letter-spacing: normal;
    text-align: center;
    text-transform: none;

    img {
      width: 25.5px;
      margin-right: .5rem;
    }
  }

  .top-item {
    height: 44px;
    background-color: #3ba5a8;
    color: #ffffff;
  }

  .top-item:active, .top-item:hover, .top-item:focus {
    border: none !important;
    box-shadow: none !important;
  }
</style>

<style lang="scss" scoped>
  .pulse {
    box-shadow: 0 0 0 0 rgba(155, 199, 90, 0);
    animation: pulse 2.5s ease infinite;
    border-radius: 50%;
  }

  @keyframes pulse {
    0% {
      box-shadow: 0 0 0 0 rgba(155, 199, 90, 0.76);
      -moz-box-shadow: 0 0 0 0 rgba(155, 199, 90, 0.76);
    }
    70% {
      box-shadow: 0 0 0 12px rgba(155, 199, 90, 0);
      -moz-box-shadow: 0 0 0 12px rgba(155, 199, 90, 0);
    }
    100% {
      box-shadow: 0 0 0 0 rgba(155, 199, 90, 0);
      -moz-box-shadow: 0 0 0 0 rgba(155, 199, 90, 0);
    }
  }

  .notif {
    background: #e14455;
    color: #fff;
    width: 20px;
    height: 20px;
    font-size: 10px;
    text-align: center;
    border-radius: 50%;
    position: absolute;
    top: 15px;
    right: 3px;
  }

  .rec {
    text-transform: none;
    font-size: 12px;
    margin-top: 1rem;
    text-align: left;
    max-width: 100%;

    .tick {
      margin: 0;
      opacity: 0;
    }

    .check-wrap {
      width: 50px;
      margin-left: 1rem;
      margin-right: 1rem;
    }

    .check-circle {
      width: 48px;
      height: 48px;
      border: solid 2px #e7e9e4;
      border-radius: 50%;
    }

    h5 {
      font-size: 14px;
      font-weight: bold;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.43;
      letter-spacing: normal;
      color: #6c6d69;
    }

    p {
      color: #6c6d69;
      margin-bottom: .2rem;
      max-width: 250px;
      font-weight: normal;
    }
  }

  .rec.complete {
    .check-circle {
      border: solid 2px #9bc75a;
    }

    .tick {
      opacity: 1;
    }

    h5, p {
      color: #a1a39e
    }
  }

  .rec:hover, .rec:focus {
    border: none;
    cursor: pointer;
  }

  .rec.complete:hover {
    cursor: default;
  }

  .close-item {
    font-size: 16px;
    position: absolute;
    right: 1rem;
    color: #fff;
    text-shadow: none;
  }

  .close-item:hover {
    cursor: pointer;
  }
</style>

<script>
export default {
  mounted() {
    document.addEventListener('click', this.checkClickOutside);
  },
  destroyed() {
    document.removeEventListener('click', this.checkClickOutside);
  },
  computed: {
    displayAdventureGuide() {
      return this.$store.state.displayAdventureGuide;
    },
    favoriteMonster() {
      return this.$store.state.favoriteMonster;
    },
    assignIdle() {
      const activeEvents = this.$store.state.events.filter(event => !event.completed);

      const spritesFiltered = this.$store.state.usersMonsters.filter((sprite) => {
        const spriteIsActive = activeEvents.find(event => event.eventOptions.sprite === sprite._id);
        return this.page === 'active' ? spriteIsActive : !spriteIsActive;
      });

      return spritesFiltered.length > 0;
    },
    allEvents() {
      return this.$store.state.events;
    },
    eventsEmpty() {
      const activeEvents = this.$store.state.events.filter(event => !event.completed);
      return activeEvents.length === 0;
    },
    metaMaskStatus() {
      return this.$store.state.metaMaskStatus;
    },
    noBlockchainSprites() {
      if (!this.$store.state.metaMaskStatus) return false;
      if (this.$store.state.usersMonsters.length <= 1) return true;
      return false;
    },
    recsCount() {
      let count = 0;

      if (this.noBlockchainSprites) count += 1;
      if (this.eventsEmpty) count += 1;
      // if (this.assignIdle) count += 1;

      return count;
    },
  },
  methods: {
    checkClickOutside(event) {
      if (event.target.closest('.guide')) return;
      this.close();
    },
    close() {
      this.$store.state.displayAdventureGuide = false;
    },
    toggleGuide() {
      this.$store.state.displayAdventureGuide = !this.$store.state.displayAdventureGuide;
    },
    goToMarket() {
      this.$router.push({ name: 'Market' });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/nav/Recomendations.vue